import React from 'react';
import { Modal } from "react-bootstrap";
import { PlanProps, ACPlans } from '../../types';
import { REPs } from '../../config';
import { KHModalTitle,KHPlanCard,KHPlanHeader,KHPlanLogo,KHPlanName,KHPlanDetails,KHPlanSummaryRow,} from '../styles/compareTable.styled';
import { Button } from "../styles/Button.styled";
interface KHPlanModalProps {
  show: boolean;
  handleClose: () => void;
  planData: PlanProps[] | null;
  acPlans: ACPlans[] | null;
  selectedPlanId: string | null;
  chartData: any[] | null;
  onSignUp?: (planId: string) => void;
}
export const KHPlanModal: React.FC<KHPlanModalProps> = ({show,handleClose,planData,acPlans,selectedPlanId,chartData,onSignUp}) => {
  if (!show) return null;
  // Find the selected plan details
  const selectedPlan = planData?.find(plan => String(plan.provider_id) === selectedPlanId);
  const selectedACPlan = acPlans?.find(plan => plan.provider_id === selectedPlanId);
  const selectedChartData = chartData?.find(item => item.id === selectedPlanId);
  // Get plan details
  const planName = selectedACPlan?.plan_name || selectedPlan?.plan_name || selectedChartData?.label || 'Plan Details';
  const planRate = selectedChartData?.value || selectedPlan?.price1000 || 0;
  const contractTerm = selectedPlan?.contract_term || '12';
  const cancelFee = selectedPlan?.earlyTerminationFee || '150';
  const cancelFeeType = 'OneTime';
  // Check if this is a Constellation plan
  const hostRep = REPs.filter(val => val.host === true);
  const isConstellationPlan = hostRep[0] && String(hostRep[0].providerId) === selectedPlanId;
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <KHModalTitle>Best plans for you</KHModalTitle>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "1rem", justifyContent: "center" }}>
        <KHPlanCard>
          <KHPlanHeader>
            <KHPlanLogo><img src={selectedPlanId === "196"? "/images/logo.png": `https://www.powerlego.com/ApiGateway/v2/logo/provider/${selectedPlanId}`} alt=""/></KHPlanLogo>
            <KHPlanName>{planName === "12 Month Usage" ? "Fixed Rate + Bill Credit" : planName}</KHPlanName>
          </KHPlanHeader>
          <KHPlanDetails>
            <KHPlanSummaryRow><label>Rate:</label><span><b>{planRate?.toFixed(1)}¢</b></span></KHPlanSummaryRow>            
            <KHPlanSummaryRow><label>Plan Length:</label><span>{contractTerm} Months</span></KHPlanSummaryRow>
            
            {selectedPlan?.plan_incentive_list?.find(
              (incentive: any) => incentive.Description === "Gift Card"
            ) && (
              <div>
                <KHPlanSummaryRow>
                  <label>Gift Card:</label>
                  <span>                    
                      ${
                        selectedPlan.plan_incentive_list?.find(
                          (incentive: any) =>
                            incentive.Description === "Gift Card"
                        )?.Value
                      }                    
                  </span>
                </KHPlanSummaryRow>
              </div>
            )}            
            {cancelFee && (
              <KHPlanSummaryRow>
                <label>Cancellation Fee:</label>                
                <span>
                ${cancelFee} ({cancelFeeType})
              </span>
              </KHPlanSummaryRow>
            )}
          </KHPlanDetails>

          {/* <KHPlanLinks>
            {(selectedPlan as any)?.yrac && (
              <KHPlanLink href={(selectedPlan as any).yrac} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2">YRAC</span>
              </KHPlanLink>
            )}

            {(selectedPlan as any)?.terms_url && (
              <KHPlanLink href={(selectedPlan as any).terms_url} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2">TOS</span>
              </KHPlanLink>
            )}

            {(selectedPlan as any)?.efl_url && (
              <KHPlanLink href={(selectedPlan as any).efl_url} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2">EFL</span>
              </KHPlanLink>
            )}
          </KHPlanLinks>

          <KHPlanPromote>
            {selectedPlan?.isEbillRequired && <span>Plan requires electronic billing. </span>}
            Please print or save these documents for your reference.
          </KHPlanPromote> */}
          {isConstellationPlan && onSignUp && selectedPlanId && (
            <Button className="mt-3" style={{ width: "100%" }} onClick={() => { onSignUp(selectedPlanId);  handleClose(); }}>
              Select Plan
            </Button>
          )}
        </KHPlanCard>
      </Modal.Body>
    </Modal>
  );
};
